import { render, staticRenderFns } from "./Valor.vue?vue&type=template&id=766ee222&"
import script from "./Valor.vue?vue&type=script&lang=js&"
export * from "./Valor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports